import {parse/*,serialize*/} from 'cookie'

// export function setCookie(...args){
//     document.cookie=serialize(...args);
// }
export function setCookie(name,value,time=1)
{
    var Days = 30;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days*24*60*60*1000*time);
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
}
export function getCookie(key){
    return (parse(document.cookie)||{})[key]
}
export function delCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval=getCookie(name);
    if(cval!=null)
        document.cookie= name + "="+cval+";expires="+exp.toGMTString();
}

